import { t } from 'i18next';
import * as yup from 'yup';

import { DefaultPricingType } from 'contacts/enums';
import { numberSchemaWithTransform } from 'core/yup';

export const defaultPricingSchema = () =>
  yup.object().shape({
    defaultPricing: yup
      .string()
      .label(t('labelDefaultPricing'))
      .oneOf(Object.values(DefaultPricingType))
      .nullable()
      .required(),
    baseMargin: numberSchemaWithTransform()
      .nullable()
      .when('defaultPricing', {
        is: DefaultPricingType.BASE_MARGIN,
        then: numberSchemaWithTransform().label(t('labelBaseMargin')).required(),
        otherwise: numberSchemaWithTransform().label(t('labelBaseMargin')).nullable(),
      }),
    baseDiscount: numberSchemaWithTransform()
      .nullable()
      .when('defaultPricing', {
        is: DefaultPricingType.BASE_DISCOUNT,
        then: numberSchemaWithTransform().label(t('labelBaseDiscount')).required(),
        otherwise: numberSchemaWithTransform().label(t('labelBaseDiscount')).nullable(),
      }),
  });
